
<template>
  <div>
    <form role="form" @submit.stop.prevent="onSubmit">
      <div class="vx-row">
        <div class="vx-col mb-6">
          <span>Ativo</span>
          <vs-switch color="success" v-model="formCadastro.status" style="width:60px;">
            <span slot="on">Ativo</span>
            <span slot="off">Inativo</span>
          </vs-switch>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Nome tipo de atendimento</span>
          <vs-input
            size="large"
            class="w-full"
            name="tipo de atendimento"
            id="tipo de atendimento"
            v-model="formCadastro.tipoRelacionamento"
            v-validate="{ required: true, min:5}"
            :state="validateState('tipo de atendimento')"
            :danger="validateClass('tipo de atendimento')"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
          />
        </div>
      </div>

      <vs-alert
        v-if="$validator.errors.all().length >0"
        color="danger"
        title="Atenção!!"
        active="true"
        class="my-3"
        style="height:auto !important"
      >
        <ul>
          <li class="mb-2" v-for="error in $validator.errors.all()" :key="error.id">{{ error }}</li>
        </ul>
      </vs-alert>
      <div class="vx-row">
        <div class="vx-col w-full text-right">
          <vs-button color="warning" type="border" class="mr-3 mb-2" @click.stop.prevent="onReset">Cancelar</vs-button>
          <BotaoSubmit
            variant="success"
            :edit="this.dados.idTipoAtendimento==null?false:true"
            :aguarde="aguardeCadastro"
          ></BotaoSubmit>
        </div>
      </div>
    </form>

    <!------------ END FORM ------------>
  </div>
</template>
<!------------ END TEMPLATE ------------>


<!------------ START SCRIPT ------------>
<script>
import locale from "./../../locale";
import * as lang from "vuejs-datepicker/src/locale";
import service from "../../services";
import BotaoSubmit from "../../components/BotaoSubmit";

export default {
  props: {
    sideBar: {
      type: Boolean
    },
    dados: {
      type: Object
    }
  },
  watch: {
    dados(value) {
      this.preencheForm();
    }
  },
  data() {
    return {
      aguardeCadastro: false,
      idEmpresa: null,
      languages: lang,
      formCadastro: {
        idTipoRelacionamento: null,
        idEmpresa: null,
        tipoRelacionamento: "",
        status: true,
      }
    };
  },
  methods: {
    preencheForm() {
      if (this.dados.idTipoRelacionamento) {
        this.formCadastro.idTipoRelacionamento = this.dados.idTipoRelacionamento;
        this.formCadastro.status = this.dados.deletedAt == null ? true : false;
        this.formCadastro.tipoRelacionamento = this.dados.tipoRelacionamento;
        this.formCadastro.idEmpresa = this.idEmpresa;
      } else {
        this.resetForm();
      }
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },
    onSubmit() {
      console.log('126 Cadastro Tipo de atendimento: ', this.formCadastro);
      this.formCadastro.idEmpresa = this.idEmpresa;
      console.log('129 formCadastro.idEmpresa: ', this.formCadastro.idEmpresa);
      
      var action = "Atualizar";
      var msgRetorno = "Dados Atualizados com sucesso";
      if (!this.formCadastro.idTipoRelacionamento) {
        action = "Adicionar";
        msgRetorno = `Registro Adicionado com sucesso`;
      }

      this.$validator.validateAll().then(result => {
        if (result) {
          this.aguardeCadastro = true;
          service
            .post("tipoAtendimento", action, this.formCadastro)
            .then(res => {
              this.aguardeCadastro = false;
              this.$vs.notify({
                position: "top-center",
                title: "Atenção",
                text: `Operação Realizada com sucesso`,
                color: "success"
              });
              this.$emit("concluido");
            })
            .catch(error => {
              this.aguardeCadastro = false;
              this.$vs.notify({
                position: "top-center",
                title: "Atenção",
                text: error,
                color: "danger"
              });
            });
        }
      });
    },
    resetForm() {
      this.formCadastro = {
        idTipoRelacionamento: null,
        idEmpresa: null,
        status: true,
        tipoRelacionamento: ""
      };
    },
    onReset(evt) {
      if (this.sideBar == true) {
        this.$emit("cancel");
      } else {
        evt.preventDefault();
        this.resetForm();
        this.$nextTick(() => {
          this.show = true;
        });
      }
    },
    obterIdEmpresa(){
      this.idEmpresa = localStorage.getItem('idEmpresa');
      console.log(187, this.idEmpresa);
    }
  },
  mounted() {
    this.obterIdEmpresa()
    this.$validator.localize("ptBr", locale);
  },
  components: {
    BotaoSubmit,
  }
};
</script>
<!------------ END SCRIPT ------------>
